import { asideLinks2 } from "constants/asideLinks2";

// Sidebar links are built with the language baked in at import time; compare
// without it so a mismatch there cannot hide a page from its section.
const withoutLanguage = (pathname) => pathname.replace(/^\/[^/]+/, "");

// Same rule the sidebar highlights a link by, minus its prefix match: a page below
// a sidebar entry names its parent in routes.js instead of being guessed from the URL.
export function linkMatches(link, pathname, search) {
  const [basePath, linkQuery] = link.split("?");
  if (withoutLanguage(basePath) !== withoutLanguage(pathname)) return false;
  if (!linkQuery) return true;

  const currentParams = new URLSearchParams(search);
  for (const [key, value] of new URLSearchParams(linkQuery).entries()) {
    if (currentParams.get(key) !== value) return false;
  }
  return true;
}

function findLeaf(entries, ancestors, isMatch) {
  for (const entry of entries) {
    if (entry.children) {
      const found = findLeaf(entry.children, [...ancestors, entry], isMatch);
      if (found) return found;
    } else if (entry.path && isMatch(entry.path)) {
      return { sections: ancestors, leaf: entry };
    }
  }
  return null;
}

/**
 * Where a top-level page sits in the sidebar: the groups above it, and the link
 * that names it. A page reached with a different query than any link (a bare
 * `/customers`) still gets its groups, but no link to borrow a name from.
 */
export function findSidebarTrail(pathname, search) {
  const exact = findLeaf(asideLinks2, [], (link) =>
    linkMatches(link, pathname, search)
  );
  if (exact) return exact;

  const samePage = findLeaf(
    asideLinks2,
    [],
    (link) => withoutLanguage(link.split("?")[0]) === withoutLanguage(pathname)
  );
  if (samePage) return { sections: samePage.sections, leaf: null };

  return { sections: [], leaf: null };
}

// A link carrying a query names its page only under that query — never the bare URL
// or the record pages below it — so it does not count here.
export function hasSidebarLink(routePath) {
  return Boolean(
    findLeaf(
      asideLinks2,
      [],
      (link) => !link.includes("?") && withoutLanguage(link) === `/${routePath}`
    )
  );
}
